module.exports = __webpack_public_path__ + "static/media/motion-paa-mars.4d0e0317.mp3";